import { c as _c } from "react/compiler-runtime";
import React from 'react';
const StoreLocatorNoResults = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div data-xc="StoreLocatorNoResults" className="py-3"><h3 className="text-base text-brand font-bold">No showroom available within range</h3></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default StoreLocatorNoResults;